export const getStripeProducts = () => {
  const config = useRuntimeConfig();
  const isProd = config.public.apiBaseUrl === 'https://api.vector.co';
  const identifiedVisitorsUnitPrice = 0.08;
  const stripeProducts = {
    free: {
      label: 'Free',
      type: 'plan',
      productId: isProd ? 'prod_QVSjLdCQGHINP0' : 'prod_QVSdWpH22ghTkb',
      price: 0,
      priceIds: {
        monthly: isProd ? 'price_1PeRoNL9PCat5EZ734uWIvJT' : 'price_1PeRihL9PCat5EZ7slGK8zkh',
        annual: isProd ? 'price_1QGXcFL9PCat5EZ7fpJqlRCI' : 'price_1QDTu1L9PCat5EZ7joOvZ7Yh',
      },
      getPrice: (): number => {
        return 0;
      },
      getLabelPrice: (): number => {
        return 0;
      },
      getDiscount: (): string => {
        return '';
      },
      getCycle: (isAnnual: boolean): string => {
        return isAnnual ? '/year' : '/month';
      },
    },
    reveal: {
      label: 'Reveal',
      type: 'plan',
      productId: isProd ? 'prod_RqrPCkMLLbkqa6' : 'prod_Rq9MPXpv5jXrrX',
      price: 199,
      priceIds: {
        monthlyFree: isProd ? 'price_1SSOF6L9PCat5EZ7hn6qEAF1' : 'price_1SSNTVL9PCat5EZ7PfrW3x76',
        monthly: isProd ? 'price_1SHTY1L9PCat5EZ7WwX0B3zn' : 'price_1SGkV2L9PCat5EZ7VQm5c8R6',
        annual: isProd ? 'price_1SHTYHL9PCat5EZ7swGmy8rg' : 'price_1SGkW9L9PCat5EZ7ywz7c3Vd',
      },
      // this is the real price people pay
      getPrice: (isAnnual: boolean, quantity: number): number => {
        return isAnnual
          ? (199 + quantity * identifiedVisitorsUnitPrice) * 10
          : 199 + quantity * identifiedVisitorsUnitPrice;
      },
      // this is the pre-discount price
      getLabelPrice: (isAnnual: boolean, quantity: number): number => {
        return isAnnual
          ? (199 + quantity * identifiedVisitorsUnitPrice) * 12
          : 199 + quantity * identifiedVisitorsUnitPrice;
      },
      getDiscount: (isAnnual: boolean, quantity: number): string => {
        return isAnnual ? `$${(199 + quantity * 0.08) * 10}` : '';
      },
      getCycle: (isAnnual: boolean): string => {
        return isAnnual ? '/year' : '/month';
      },
    },
    revealAnnual: {
      label: 'Reveal Annual',
      type: 'plan',
      productId: isProd ? 'prod_USgeTsTLrnIDeI' : 'prod_USPug7NHLPYyPO',
      price: 1000,
      priceIds: {
        monthly: isProd ? 'price_1TTlHdL9PCat5EZ7Qv6XLil1' : 'price_1TTX2qL9PCat5EZ7QpSWgOoY',
        annual: isProd ? 'price_1TTlH8L9PCat5EZ7w9mOawBZ' : 'price_1TTV4IL9PCat5EZ7X7AKZdEs',
      },
      getPrice: (isAnnual: boolean): number => {
        return isAnnual ? 1000 * 12 : 1000;
      },
      getLabelPrice: (isAnnual: boolean): number => {
        return isAnnual ? 1000 * 12 : 1000;
      },
      getDiscount: (): string => {
        return '';
      },
      getCycle: (isAnnual: boolean): string => {
        return isAnnual ? '/year' : '/month (paid annually)';
      },
    },
    target: {
      label: 'Target',
      type: 'plan',
      productId: isProd ? 'prod_QjxuEzwABWP0NQ' : 'prod_QhnUryTPVYCPED',
      price: 3000,
      priceIds: {
        monthly: isProd ? 'price_1Pu16LL9PCat5EZ7FGo8ReWH' : 'price_1PrU3wL9PCat5EZ7mT040H9W',
        annual: isProd ? 'price_1QybaqL9PCat5EZ7PXmRo1yx' : 'price_1Qybm2L9PCat5EZ70qAhn7lk',
      },
      getPrice: (isAnnual: boolean): number => {
        return isAnnual ? 3000 * 12 : 3000;
      },
      getLabelPrice: (isAnnual: boolean): number => {
        return isAnnual ? 3000 * 12 : 3000;
      },
      getDiscount: (): string => {
        return '';
      },
      getCycle: (isAnnual: boolean): string => {
        return isAnnual ? '/year' : '/month (paid annually)';
      },
    },
    api: {
      label: 'API',
      type: 'plan',
      productId: isProd ? 'prod_TPZi3pE5p43P3g' : 'prod_TPWdlx6VIaSUy8',
      price: 0,
      priceIds: {
        monthly: isProd ? 'price_1SSkZML9PCat5EZ7fj38CrIQ' : 'price_1SShaPL9PCat5EZ7HAK66qzg',
        annual: isProd ? 'price_1TTjG0L9PCat5EZ7a2MT589f' : 'price_1TTjLzL9PCat5EZ7bZlQAtpr',
      },
    },
    identifiedVisitors: {
      label: 'Identified visitors',
      type: 'addOn',
      productId: isProd ? 'prod_TDvgOM9tE1MNHc' : 'prod_TBFqhMwK8u9LzB',
      price: 200,
      priceIds: {
        monthly: isProd ? 'price_1SHTq7L9PCat5EZ7P4tVZTLs' : 'price_1SGThmL9PCat5EZ7QWRra7gL',
        annual: isProd ? 'price_1SHTqOL9PCat5EZ7jpiKIAQT' : 'price_1SGUtfL9PCat5EZ7pu7nzenx',
      },
    },
    adAudiences: {
      label: 'Ad audiences',
      type: 'addOn',
      productId: isProd ? 'prod_TDvegpkznQhhCx' : 'prod_TBFqTrPTt5TVO3',
      price: 0,
      priceIds: {
        monthly: isProd ? 'price_1SHTnPL9PCat5EZ7244AwetN' : 'price_1SEtKyL9PCat5EZ7dSZSDTB4',
        annual: isProd ? 'price_1SHTnmL9PCat5EZ7P8k54Cbl' : 'price_1SGMEaL9PCat5EZ7Q15Ghvfa',
      },
    },
    bidAgents: {
      label: 'Bid agents',
      type: 'addOn',
      productId: isProd ? 'prod_TMF4aZnUA2Qcvf' : 'prod_TL0T0NWY7RyQ1H',
      price: 0,
      priceIds: {
        monthly: isProd ? 'price_1SPWa3L9PCat5EZ7WI33ZAh9' : 'price_1SOKSVL9PCat5EZ7tIY02Wxq',
        monthlyFree: isProd ? 'price_1SPWaML9PCat5EZ7o8Or8ReD' : 'price_1SOs3XL9PCat5EZ7MPIDjA1r',
        annual: isProd ? 'price_1SPWaXL9PCat5EZ7chHZNAsy' : 'price_1SPWYfL9PCat5EZ7muAlBi8u',
        annualFree: isProd ? 'price_1SPWagL9PCat5EZ7oLRGbzMb' : 'price_1SPWZ3L9PCat5EZ7tmx1B7B2',
      },
    },
  };
  return stripeProducts;
};

export const getPlanObjs = (stripeProducts: any) => {
  return [
    {
      id: 'free',
      name: 'Free',
      price: stripeProducts.free.price,
      productId: stripeProducts.free.productId,
      description: 'De-anonymize visitors on your site',
      features: [
        'Site visitor identification',
        'ICP filtering',
        'Up to 2 segments',
        'Slack, Clay, and Webhook integrations',
        'Real-time visitor feed',
        'Up to 1k contact exports per month',
      ],
      prices: {
        monthly: stripeProducts.free.priceIds.monthly,
        annual: stripeProducts.free.priceIds.annual,
      },
      getPrice: stripeProducts.free.getPrice,
      getLabelPrice: stripeProducts.free.getLabelPrice,
      getDiscount: stripeProducts.free.getDiscount,
      getCycle: stripeProducts.free.getCycle,
      isCurrent: false,
    },
    {
      id: 'reveal',
      name: 'Reveal',
      price: stripeProducts.reveal.price,
      productId: stripeProducts.reveal.productId,
      description: "See who's on your site instantly by name, company, and title",
      features: [
        "Ad Reveal: see who clicks your ads, even if they don't convert",
        'CRM-ready: sync directly to Salesforce and HubSpot to fuel follow-up',
        'Site De-anonymization: turn anonymous visitors into named contacts (name, title, company)',
        'Fast setup: live in days with chat/email support and a Help Center',
      ],
      prices: {
        monthly: stripeProducts.reveal.priceIds.monthly,
        annual: stripeProducts.reveal.priceIds.annual,
      },
      getPrice: stripeProducts.reveal.getPrice,
      getLabelPrice: stripeProducts.reveal.getLabelPrice,
      getDiscount: stripeProducts.reveal.getDiscount,
      getCycle: stripeProducts.reveal.getCycle,
      isCurrent: false,
    },
    {
      id: 'target',
      name: 'Target',
      price: stripeProducts.target.price,
      productId: stripeProducts.target.productId,
      description: 'Reveal in-market buyers before they land on your site',
      features: [
        'Everything in Reveal',
        'Signal-driven audiences: ads refresh automatically as buyers visit pages, research competitors, or change roles',
        'ICP at scale: run multi-channel campaigns that match your exact buyer profile',
        'Advanced integrations: push data via webhooks, custom CRM mapping, and UTM sync',
      ],
      prices: {
        monthly: stripeProducts.target.priceIds.monthly,
        annual: stripeProducts.target.priceIds.annual,
      },
      getPrice: stripeProducts.target.getPrice,
      getLabelPrice: stripeProducts.target.getLabelPrice,
      getDiscount: stripeProducts.target.getDiscount,
      getCycle: stripeProducts.target.getCycle,
      isCurrent: false,
    },
  ];
};
